<table>
    <!-- start header -->
    <thead>
        <ng-container *ngFor="let header of printPreviewData.header; let headerIndex = index">
            <tr class="row-min-height_plus-border-height">
                <th class="flex-row row-min-height strong-separator" [ngClass]="{ multipleHeader: headerIndex > 0 }">
                    <div class="flex-row header">
                        <div
                            class="text header-footer header-cell-container"
                            stylePreference
                            [textColor]="textColor"
                            backgroundColor="white"
                            [ngClass]="{
                                'text-longer-width': noPreviousData && printPreviewData.header.length === 1,
                                'text-longer-width-with-no-previous':
                                    noPreviousData && printPreviewData.header.length > 1
                            }"
                        >
                            <span class="header-cell-text">
                                {{ header.text }}

                                {{ printPreviewData.displayCurrency ? (inWordKey | i18next) : '' }}
                                {{ printPreviewData.displayCurrency ? currency : '' }}
                            </span>
                        </div>
                        <div
                            *ngIf="header.displayOpeningAndClosingValues"
                            class="value header-footer colored-value header-cell-container"
                            stylePreference
                            [textColor]="textColor"
                            [backgroundColor]="backgroundColor"
                            [ngClass]="{
                                'no-previous-value-header': noPreviousData && printPreviewData.header.length > 1
                            }"
                        >
                            <span class="content header-cell-text">
                                {{
                                    header.currentValue != null && isIsoDate(header.currentValue.toString())
                                        ? (header.currentValue.toString() | dateLocale)
                                        : header.currentValue
                                }}
                            </span>
                        </div>
                        <div
                            *ngIf="
                                (!noPreviousData || (printPreviewData.header.length > 1 && headerIndex !== 0)) &&
                                header.displayOpeningAndClosingValues
                            "
                            class="separator-column"
                            stylePreference
                            [backgroundColor]="backgroundColor"
                        ></div>
                        <div
                            *ngIf="header.currentValue2 && header.displayOpeningAndClosingValues"
                            class="value header-footer colored-value header-cell-container"
                            stylePreference
                            [textColor]="textColor"
                            [backgroundColor]="backgroundColor"
                        >
                            <span class="content header-cell-text">
                                {{
                                    isOfTypeNumber(header.currentValue2)
                                        ? (getNumber(header.currentValue2) | finNumber : numberFormat)
                                        : header.currentValue2
                                }}
                            </span>
                        </div>
                        <div
                            *ngIf="header.currentValue2 && !noPreviousData && header.displayOpeningAndClosingValues"
                            class="separator-column"
                            stylePreference
                            [backgroundColor]="backgroundColor"
                        ></div>
                        <div
                            *ngIf="!noPreviousData && header.displayOpeningAndClosingValues"
                            class="value header-footer header-cell-container"
                            stylePreference
                            [textColor]="textColor"
                            backgroundColor="white"
                        >
                            <span class="content header-cell-text">
                                {{
                                    header.previousValue != null && isIsoDate(header.previousValue.toString())
                                        ? (header.previousValue.toString() | dateLocale)
                                        : header.previousValue
                                }}
                            </span>
                        </div>
                        <div
                            *ngIf="header.previousValue2 && !noPreviousData"
                            class="value header-footer header-cell-container"
                            stylePreference
                            [textColor]="textColor"
                            backgroundColor="white"
                        >
                            <span class="content header-cell-text">
                                {{ header.previousValue2 }}
                            </span>
                        </div>
                    </div>
                </th>
            </tr>
        </ng-container>
    </thead>

    <!-- end of header -->

    <!-- start of rows  -->
    <tbody>
        <ng-container *ngFor="let row of printPreviewData.rows; let rowIndex = index">
            <tr class="row-min-height_plus-border-height">
                <td
                    class="flex-row row-min-height"
                    [ngClass]="{
                        multipleHeaderRow: printPreviewData.header.length > 1,
                        'strong-separator': rowIndex === printPreviewData.rows.length - 1,
                        'gray-border-down': rowIndex !== printPreviewData.rows.length - 1
                    }"
                >
                    <div
                        class="text"
                        stylePreference
                        [textColor]="textColor"
                        backgroundColor="white"
                        [ngClass]="{
                            'text-longer-width': noPreviousData && printPreviewData.header.length === 1,
                            'text-longer-width-with-no-previous': noPreviousData && printPreviewData.header.length > 1
                        }"
                    >
                        <span>
                            {{ row.text }}
                        </span>
                    </div>
                    <div
                        class="value colored-value"
                        stylePreference
                        [textColor]="textColor"
                        [backgroundColor]="backgroundColor"
                    >
                        <span class="content">
                            {{
                                isOfTypeNumber(row.currentValue)
                                    ? (getNumber(row.currentValue) | finNumber : numberFormat)
                                    : row.currentValue
                            }}
                        </span>
                    </div>
                    <div
                        *ngIf="!noPreviousData || printPreviewData.header.length > 1"
                        class="separator-column"
                        stylePreference
                        [backgroundColor]="backgroundColor"
                    ></div>
                    <div
                        *ngIf="printPreviewData.header.length > 1"
                        class="value colored-value"
                        stylePreference
                        [textColor]="textColor"
                        [backgroundColor]="backgroundColor"
                    >
                        <span class="content">
                            {{
                                isOfTypeNumber(row.currentValue2)
                                    ? (getNumber(row.currentValue2) | finNumber : numberFormat)
                                    : row.currentValue2
                            }}
                        </span>
                    </div>
                    <div
                        *ngIf="printPreviewData.header.length > 1 && !noPreviousData"
                        class="separator-column"
                        stylePreference
                        [backgroundColor]="backgroundColor"
                    ></div>
                    <div
                        *ngIf="!noPreviousData"
                        class="value"
                        stylePreference
                        [textColor]="textColor"
                        backgroundColor="white"
                    >
                        <span class="content">
                            {{
                                isOfTypeNumber(row.previousValue)
                                    ? (getNumber(row.previousValue) | finNumber : numberFormat)
                                    : row.previousValue
                            }}
                        </span>
                    </div>
                    <div
                        *ngIf="row.previousValue2 != null && !noPreviousData"
                        class="value"
                        stylePreference
                        [textColor]="textColor"
                        backgroundColor="white"
                    >
                        <span class="content">
                            {{
                                isOfTypeNumber(row.previousValue2)
                                    ? (getNumber(row.previousValue2) | finNumber : numberFormat)
                                    : row.previousValue2
                            }}
                        </span>
                    </div>
                </td>
            </tr>
        </ng-container>
        <!-- end of row  -->

        <!-- start footer  -->
        <ng-container *ngIf="printPreviewData.footer != null">
            <tr class="row-min-height_plus-border-height">
                <td
                    class="flex-row header row-min-height strong-separator"
                    [ngClass]="{
                        multipleHeaderFooter: printPreviewData.header.length > 1
                    }"
                >
                    <div
                        class="text header-footer"
                        stylePreference
                        [textColor]="textColor"
                        backgroundColor="white"
                        [ngClass]="{
                            'text-longer-width': noPreviousData && printPreviewData.header.length === 1,
                            'text-longer-width-with-no-previous': noPreviousData && printPreviewData.header.length > 1
                        }"
                    >
                        {{ printPreviewData.footer.text }}
                    </div>
                    <div
                        class="value header-footer colored-value"
                        stylePreference
                        [textColor]="textColor"
                        [backgroundColor]="backgroundColor"
                    >
                        <span class="content">
                            {{
                                isOfTypeNumber(printPreviewData.footer.currentValue)
                                    ? (getNumber(printPreviewData.footer.currentValue) | finNumber : numberFormat)
                                    : printPreviewData.footer.currentValue
                            }}
                        </span>
                    </div>
                    <div
                        *ngIf="!noPreviousData || printPreviewData.header.length > 1"
                        class="separator-column"
                        stylePreference
                        [backgroundColor]="backgroundColor"
                    ></div>
                    <div
                        *ngIf="printPreviewData.footer.currentValue2 != null"
                        class="value header-footer colored-value"
                        stylePreference
                        [textColor]="textColor"
                        [backgroundColor]="backgroundColor"
                    >
                        <span class="content">
                            {{
                                isOfTypeNumber(printPreviewData.footer.currentValue2)
                                    ? (getNumber(printPreviewData.footer.currentValue2) | finNumber : numberFormat)
                                    : printPreviewData.footer.currentValue2
                            }}
                        </span>
                    </div>
                    <div
                        *ngIf="printPreviewData.footer.currentValue2 != null && !noPreviousData"
                        class="separator-column"
                        stylePreference
                        [backgroundColor]="backgroundColor"
                    ></div>
                    <div
                        *ngIf="!noPreviousData"
                        class="value header-footer"
                        stylePreference
                        [textColor]="textColor"
                        backgroundColor="white"
                    >
                        <span class="content">
                            {{
                                isOfTypeNumber(printPreviewData.footer.previousValue)
                                    ? (getNumber(printPreviewData.footer.previousValue) | finNumber : numberFormat)
                                    : printPreviewData.footer.previousValue
                            }}
                        </span>
                    </div>
                    <div
                        *ngIf="printPreviewData.footer.previousValue2 != null && !noPreviousData"
                        class="value header-footer"
                        stylePreference
                        [textColor]="textColor"
                        backgroundColor="white"
                    >
                        <span class="content">
                            {{
                                isOfTypeNumber(printPreviewData.footer.previousValue2)
                                    ? (getNumber(printPreviewData.footer.previousValue2) | finNumber : numberFormat)
                                    : printPreviewData.footer.previousValue2
                            }}
                        </span>
                    </div>
                </td>
            </tr>
        </ng-container>
    </tbody>
    <tfoot>
        <tr class="row-min-height_plus-border-height">
            <td>
                <div class="row-min-height" stylePreference [textColor]="textColor" backgroundColor="white"></div>
            </td>
        </tr>
    </tfoot>

    <!-- end of footer  -->
</table>
